import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StoreAvailabilityService {
    /**
     * Get Store Availability Config
     * @param chain
     * @returns StoreAvailabilityConfig Successful Response
     * @throws ApiError
     */
    static getStoreAvailabilityConfigStoreAvailabilityConfigGetGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_availability/config/get',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Store Availability Config
     * @param chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setStoreAvailabilityConfigStoreAvailabilityConfigSetPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/config/set',
            query: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Availability Bname Config Api
     * @param chain
     * @param requestBody
     * @returns StoreAvailabilityBnameConfigResponse Successful Response
     * @throws ApiError
     */
    static getStoreAvailabilityBnameConfigApiStoreAvailabilityBnameConfigGetPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/bname/config/get',
            query: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Store Availability Bname Config Api
     * @param chain
     * @param requestBody
     * @returns StoreAvailabilityBnameConfigResponse Successful Response
     * @throws ApiError
     */
    static setStoreAvailabilityBnameConfigApiStoreAvailabilityBnameConfigSetPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/bname/config/set',
            query: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Sms Preferences
     * @param uid
     * @returns SMSPreferences Successful Response
     * @throws ApiError
     */
    static getSmsPreferencesSmsPreferencesGetGet(uid) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sms/preferences/get',
            query: {
                'uid': uid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Sms Preferences
     * @param uid
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setSmsPreferencesSmsPreferencesSetPost(uid, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sms/preferences/set',
            query: {
                'uid': uid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Migrate Store Availability Users
     * If realtime is true, migrate all users of the given chains from store availability hourly sms to realtime auto alert.
     * Otherwise, migrate all users of the given chains from store availability realtime sms to hourly sms.
     * @param requestBody
     * @param realtime
     * @param migrateBusinessAdmins
     * @returns any Successful Response
     * @throws ApiError
     */
    static migrateStoreAvailabilityUsersStoreAvailabilityUsersMigratePost(requestBody, realtime = true, migrateBusinessAdmins = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/users/migrate',
            query: {
                'realtime': realtime,
                'migrate_business_admins': migrateBusinessAdmins,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Process Inactive Store
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static processInactiveStoreStoreAvailabilityProcessInactiveStorePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/process_inactive_store',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Screenshot Inactive Store
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static screenshotInactiveStoreStoreAvailabilityScreenshotInactiveStorePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/screenshot/inactive_store',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Store Online
     * Tries to set the store status online. Returns true or false indicating success.
     * Manual indicates that this API was triggered from frontend and not from Internal service.
     * Supports all platforms.
     * @param slug
     * @param manual
     * @param pollTimestamp
     * @returns any Successful Response
     * @throws ApiError
     */
    static setStoreOnlineStoreAvailabilitySetStoreOnlinePost(slug, manual = false, pollTimestamp) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/set/store/online',
            query: {
                'slug': slug,
                'manual': manual,
                'poll_timestamp': pollTimestamp,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Auto Turn On Downtime Summary
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static autoTurnOnDowntimeSummaryStoreAvailabilityAutoTurnOnDowntimeSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/auto_turn_on/downtime/summary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Auto Turn On Notifications Summary
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static autoTurnOnNotificationsSummaryStoreAvailabilityAutoTurnOnNotificationsSummaryPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/auto_turn_on/notifications/summary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Stores Uptime
     * @param requestBody
     * @returns StoreAvailabilityUptimeResponse Successful Response
     * @throws ApiError
     */
    static storesUptimeStoreAvailabilityStoresUptimePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability/stores/uptime',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Store Availability Report Bname Config
     * @param chain
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setStoreAvailabilityReportBnameConfigStoreAvailabilityReportBnameConfigSetPost(chain, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/store_availability_report/bname/config/set',
            query: {
                'chain': chain,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Availability Report Bname Config
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static getStoreAvailabilityReportBnameConfigStoreAvailabilityReportBnameConfigGetGet(chain) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_availability_report/bname/config/get',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Down Reason Types
     * @returns any Successful Response
     * @throws ApiError
     */
    static getStoreDownReasonTypesStoreDownReasonTypesGetGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/store_down_reason/types/get',
        });
    }
}
